export default __webpack_public_path__ + "img/fondo.188d0701.jpg";